import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79b9dcc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "outset_div"
}
const _hoisted_2 = { class: "shop_title" }
const _hoisted_3 = { class: "img" }
const _hoisted_4 = { class: "shop_detail" }
const _hoisted_5 = { class: "shop_name" }
const _hoisted_6 = { class: "p_num" }
const _hoisted_7 = { class: "list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "position" }, "店长", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leader" }, "负责人", -1))
const _hoisted_13 = {
  key: 1,
  class: "position"
}
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = { class: "tell" }
const _hoisted_16 = {
  key: 0,
  class: "btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!

  return ($setup.storeInfo.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_image, {
              width: "75px",
              height: "75px",
              round: "",
              src: $setup.storeInfo.data.logo_info?.photo_thumb_file
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.storeInfo.data.stores_name), 1),
            _createElementVNode("div", _hoisted_6, "店铺人数：" + _toDisplayString($setup.storeInfo.userList.length) + "人", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.userList, (user) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              style: {"margin-top":"16px"},
              key: user.id,
              onClick: ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.PERSONNEL_DETAILS,
            query: {
              userId: user.id,
              master: $setup.userInfo.id === $setup.storeInfo.data.user_id
            }
          })
        )
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(user.name), 1),
                ($setup.storeInfo.data.user_id === user.id)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_11,
                      _hoisted_12
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(user.duty_name), 1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(user.mobile), 1),
                _createVNode(_component_van_icon, {
                  name: "arrow",
                  size: "1"
                })
              ])
            ], 8, _hoisted_8))
          }), 128))
        ]),
        ($setup.userInfo.id === $setup.storeInfo.data.user_id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_van_button, {
                type: "primary",
                block: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.ADD_PERSON
          })
        ))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增人员")
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}